import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "action-task",
  "use": "action-task-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"action-task\"><path fill-rule=\"evenodd\" d=\"m7.5 2-1 11h4l-1 9 8-13h-5.999L15.5 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol